import * as React from "react";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import AddLeadForm from "./form/create/AddLeadForm";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import Routes from "../../navigation/route/Route";
import {Boxed} from "../../hiberUiKit/src/molecules/Boxed/Boxed";

type Props = RouteComponentProps<any>;

/**
 * Create lead view.
 */
class CreateLead extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create new lead"}/>
				<PageContentView>
					<AddLeadForm onSuccess={this.onSuccess}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully added contact.
	 */
	private onSuccess() {
		this.props.history.push(Routes.LeadsList);
	}
}

export default withRouter(CreateLead);